export default "__VITE_ASSET__67e7fac4__"